// extracted by mini-css-extract-plugin
export default {"mobileVert":"mobileVert--z5KQy","root":"root--u66KM"};